export default {
  title: 'Haz clic o arrastra el archivo a esta área para subirlo',
  description: 'Compatible con formatos .csv, .xls, .xlsx',
  buttons: {
    download_template: 'Descargar plantilla de importación',
  },
  toasts: {
    error: 'Error al subir el archivo',
  },
};
